import{Kind}from"graphql";export function isDocumentNode(object){return object&&"object"==typeof object&&"kind"in object&&object.kind===Kind.DOCUMENT}